import {
  PillProps as MantinePillProps,
  Pill as MantinePill,
  PillGroupProps as MantinePillGroupProps,
  PillGroup as MantinePillGroup,
} from '@mantine/core';

export type PillProps = MantinePillProps;
export type PillGroupProps = MantinePillGroupProps;

export const Pill = MantinePill;
Pill.displayName = 'Pill';

export const PillGroup = MantinePillGroup;
PillGroup.displayName = 'PillGroup';
